import React from "react";
import { ChevronDown } from "react-feather";
import {
  Chevron,
  CountBadge,
  IconSlot,
  Label,
  LabelGroup,
  Row,
  ValueSlot,
} from "./KgInspectorDetailRow.styles";
import type { KgInspectorDetailRowProps } from "./KgInspectorDetailRow.types";

export const KgInspectorDetailRow: React.FC<KgInspectorDetailRowProps> = ({
  icon,
  label,
  value,
  badge,
  onToggle,
  isOpen = false,
}) => {
  const clickable = typeof onToggle === "function";
  return (
    <Row
      $clickable={clickable}
      $hideBorder={clickable}
      $isOpen={clickable && isOpen}
      onClick={clickable ? onToggle : undefined}
      role={clickable ? "button" : undefined}
      aria-expanded={clickable ? isOpen : undefined}
    >
      <LabelGroup>
        <IconSlot>{icon}</IconSlot>
        <Label $active={clickable && isOpen}>{label}</Label>
        {badge !== undefined && badge !== null && (
          <CountBadge>{badge}</CountBadge>
        )}
      </LabelGroup>
      <ValueSlot>
        {value}
        {clickable && (
          <Chevron $isOpen={isOpen}>
            <ChevronDown size={20} />
          </Chevron>
        )}
      </ValueSlot>
    </Row>
  );
};

export default KgInspectorDetailRow;
